'use client';

import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface ProductsTableSkeletonProps {
  rows?: number;
}

/**
 * ProductsTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function ProductsTableSkeleton({ rows = 10 }: ProductsTableSkeletonProps) {
  return (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
      <>
        {Array.from({ length: rows }, (_, index) => (
          <TableRow key={index}>
            {/* Select Checkbox */}
            <TableCell className="w-10">
              <Skeleton height={16} width={16} />
            </TableCell>

            {/* Product Image */}
            <TableCell className="w-16">
              <Skeleton height={40} width={40} borderRadius="0.25rem" />
            </TableCell>

            {/* Product Name & Description */}
            <TableCell>
              <div className="space-y-1">
                <Skeleton height={16} width={180} />
                <Skeleton height={12} width={120} />
              </div>
            </TableCell>

            {/* Price */}
            <TableCell className="w-32 text-right">
              <div className="space-y-1">
                <Skeleton height={16} width={60} />
                <Skeleton height={10} width={80} />
              </div>
            </TableCell>

            {/* Type Badge */}
            <TableCell className="w-24">
              <Skeleton height={20} width={70} borderRadius="0.375rem" />
            </TableCell>

            {/* Actions */}
            <TableCell className="w-10">
              <Skeleton height={32} width={32} borderRadius="0.25rem" />
            </TableCell>
          </TableRow>
        ))}
      </>
    </SkeletonTheme>
  );
}
